// Ignore a fire-and-forget promise's result — our lint bans `void`, so use this instead.
export const ignoreError = (): undefined => undefined;
